export default __webpack_public_path__ + "img/90701bc18f4bf15b9683a422f82b8b89.svg";